export default __webpack_public_path__ + "static/0g_mobile-aec5578ee0486a4d39e394588ac6da26.jpg";